// extracted by mini-css-extract-plugin
export var active = "_af-a";
export var activeIndicator = "_af-8";
export var animate = "_af-9";
export var disabled = "_af-b";
export var fullWidth = "_af-2";
export var lg = "_af-7";
export var md = "_af-6";
export var redoButtonTabGroup = "_af-0";
export var sm = "_af-5";
export var tabButton = "_af-3";
export var tabButtonsContainer = "_af-1";
export var xs = "_af-4";